import { ZERO_ROTATION } from '@sb/geometry';

export const DefaultTooltipTransform = {
  ...ZERO_ROTATION,
  x: 0,
  y: 0,
  z: 0.125,
} as const;

export const DH_DEFAULT_COLLISION_BOX = {
  origin: { x: 0, y: 0, z: 0.154 / 2 },
  size: { x: 0.109, y: 0.081, z: 0.154 },
} as const;

export const ModbusReadInitializationTimeoutMillis = 1_000;

export const DH_MIN_FORCE_PERCENT = 0.2;
export const DH_MAX_FORCE_PERCENT = 1;
